import { createAuthClient } from "better-auth/react";

const BASE_URL = import.meta.env.VITE_API_BASE_URL
console.log('BASE_URL=', BASE_URL)

export const authClient = createAuthClient({
  baseURL: BASE_URL || "http://localhost:3001",
});

export const { signIn, signUp, useSession, signOut } = authClient;
